<template>
  <div class="features-page">
    <div class="fp-wrap">
      <!-- ===== Header ===== -->
      <div class="fp-header reveal">
        <div class="fp-badge">{{ lg.fp_badge }}</div>
        <h1 class="fp-title">{{ lg.fp_title }}</h1>
        <p class="text-lg">{{ lg.fp_subtitle }}</p>
      </div>

      <!-- ===== Main features (สลับซ้าย-ขวา) ===== -->
      <div class="fp-list">
        <div
          v-for="(f, i) in mainFeatures"
          :key="f.key"
          class="fp-row reveal"
          :class="{ 'fp-row--reverse': i % 2 === 1 }"
        >
          <div class="fp-text">
            <div class="fp-icon">
              <v-icon size="32" color="#215295">{{ f.icon }}</v-icon>
            </div>
            <h2 class="fp-row-title">{{ lg['fp_' + f.key + '_title'] }}</h2>
            <p class="text-lg">{{ lg['fp_' + f.key + '_desc'] }}</p>
          </div>
          <div class="fp-media">
            <div class="fp-img">
              <img :src="f.image" :alt="lg['fp_' + f.key + '_title']" />
            </div>
          </div>
        </div>
      </div>

      <!-- ===== Premium ===== -->
      <section class="fp-premium">
        <div class="fp-premium-head reveal">
          <h2 class="fp-section-title">{{ lg.fp_premium_title }}</h2>
          <p class="text-lg">{{ lg.fp_premium_subtitle }}</p>
        </div>
        <div class="fp-premium-grid">
          <div
            v-for="p in premiumFeatures"
            :key="p.key"
            class="fp-premium-card reveal"
          >
            <div class="fp-icon fp-icon--sm">
              <v-icon size="28" color="#215295">{{ p.icon }}</v-icon>
            </div>
            <h3 class="fp-card-title">{{ lg['fp_' + p.key + '_title'] }}</h3>
            <p class="fp-card-desc">{{ lg['fp_' + p.key + '_desc'] }}</p>
            <ul class="fp-bullets">
              <li v-for="n in 4" :key="n">
                <span class="dot"></span>
                <span>{{ lg['fp_' + p.key + '_item' + n] }}</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <!-- ===== CTA ===== -->
      <section class="fp-cta">
        <div class="reveal">
          <h2 class="fp-cta-title">{{ lg.fp_cta_title }}</h2>
          <p class="fp-cta-subtitle">{{ lg.fp_cta_subtitle }}</p>
          <div class="fp-cta-actions">
            <!-- @click="onClickMenu('/register-account')" -->
            <button type="button" class="cta-btn cta-btn--white" @click="onClickMenu('/register-account')">
              {{ lg.fp_cta_start }}
            </button>
            <button
              type="button"
              class="cta-btn cta-btn--outline"
              @click="onClickMenu('/contact')"
            >
              {{ lg.fp_cta_contact }}
            </button>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import { server, feature } from "../services/constants";
import { lg_header_feature } from "./language/lg_header_feature.js";

export default {
  name: "FeaturesPage",
  data: () => ({
    lg: {},
    mainFeatures: [
  { key: "hd",     icon: "mdi-video-outline",         image: require("@/assets/img-hd-video.jpg") },
  { key: "screen", icon: "mdi-share-variant-outline", image: require("@/assets/img-screen-sharing.jpg") },
  { key: "chat",   icon: "mdi-message-outline",       image: require("@/assets/img-chat-sharing.jpg") },
  { key: "record", icon: "mdi-clock-outline",         image: require("@/assets/img-recording.jpg") },
  { key: "voting", icon: "mdi-chart-bar",             image: require("@/assets/img-voting-poll.jpg") },
  { key: "report", icon: "mdi-file-document-outline", image: require("@/assets/img-vote-report.jpg") },
    ],
    premiumFeatures: [
      { key: "legal", icon: "mdi-account-multiple-outline" },
      { key: "support", icon: "mdi-headphones" },
    ],
    scrollHandler: null,
    timers: [],
  }),
  created() {
    this.$store.state.page_reload = false;
    this.$store.state.loadFooter = true;
    this.lg =
      localStorage.getItem(feature.LANGUAGE) === "th"
        ? lg_header_feature.lg_header_feature_th
        : lg_header_feature.lg_header_feature_en;
  },
  mounted() {
    const userId = localStorage.getItem(server.USER_ID);
    if (userId && api.isLoggedIn()) {
      this.$router.push("/listroom");
      return;
    }

     // ให้ animation แสดงครั้งแรกครั้งเดียว
    // this.$el.querySelectorAll(".reveal").forEach((el, i) => {
    //   this.timers.push(
    //     setTimeout(() => el.classList.add("reveal--visible"), 200 + i * 150)
    //   );
    // });
    // ให้ animation เปลี่ยนทุกครั้ง เมื่อ scoll ขึ้นลง
    const targets = Array.from(this.$el.querySelectorAll(".reveal"));
        
    const inView = (el) => {
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const rect = el.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < vh - 100;
    };

        // 1) ตอนโหลดหน้า: ส่วนที่อยู่ในจอสไลด์ขึ้นทีละตัว
    let order = 0;
    targets.forEach((el) => {
      if (inView(el)) {
        this.timers.push(
          setTimeout(() => el.classList.add("reveal--visible"), 200 + order++ * 150)
        );
      }
    });

        // 2) ตอน scroll: fade in เมื่อเข้าจอ / fade out เมื่อออกจอ
    this.scrollHandler = () =>
      targets.forEach((el) => el.classList.toggle("reveal--visible", inView(el)));
    document.addEventListener("scroll", this.scrollHandler);
    this.scrollHandler();
  },
  beforeDestroy() {
    this.cleanup();
  },
  beforeUnmount() {
    this.cleanup();
  },
  methods: {
    cleanup() {
      if (this.scrollHandler) {
        document.removeEventListener("scroll", this.scrollHandler);
        this.scrollHandler = null;
      }
      this.timers.forEach(clearTimeout);
      this.timers = [];
    },
    onClickMenu(link) {
      this.$router.push(link);
    },
  },
};
</script>

<style scoped>
.features-page {
  min-height: 100vh;
  padding: 80px 0;
  background: #ffffff;
  color: #0a0a0a;
}
.fp-wrap {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 16px;
}
@media (min-width: 640px) {
  .fp-wrap { padding: 0 24px; }
}
@media (min-width: 1024px) {
  .fp-wrap { padding: 0 32px; }
}
.text-lg {
  font-size: 1.25rem;
  line-height: 1.75rem;
  color: #4b5563;
  margin: 0;
}

/* Header */
.fp-header {
  text-align: center;
  margin-bottom: 64px;
}
.fp-badge {
  display: inline-block;
  padding: 8px 16px;
  border-radius: 9999px;
  font-size: 0.875rem;
  margin-bottom: 24px;
  background-color: rgba(33, 82, 149, 0.1);
  color: #215295;
}
.fp-title {
  font-size: 3rem;
  line-height: 1.1;
  font-weight: 500;
  white-space: pre-line;
  margin: 0 0 16px;
}

/* Main features */
.fp-list {
  display: flex;
  flex-direction: column;
  gap: 80px;
  margin-bottom: 80px;
}
.fp-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 48px;
  align-items: center;
}
@media (min-width: 1024px) {
  .fp-row { grid-template-columns: 1fr 1fr; }
  .fp-row--reverse .fp-text { order: 2; }
  .fp-row--reverse .fp-media { order: 1; }
}
.fp-icon {
  width: 64px;
  height: 64px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  background-color: rgba(33, 82, 149, 0.1);
}
.fp-icon--sm {
  width: 56px;
  height: 56px;
  border-radius: 8px;
  margin-bottom: 16px;
}
.fp-row-title {
  font-size: 1.875rem;
  line-height: 2.25rem;
  font-weight: 500;
  margin: 0 0 16px;
}
.fp-img {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 8px 10px -6px rgba(0, 0, 0, 0.1);
}
.fp-img img {
  width: 100%;
  height: 288px;
  object-fit: cover;
  display: block;
}

/* Premium */
.fp-premium {
  margin-bottom: 80px;
}
.fp-premium-head {
  text-align: center;
  margin-bottom: 64px;
}
.fp-section-title {
  font-size: 2.25rem;
  line-height: 2.5rem;
  font-weight: 500;
  margin: 0 0 16px;
}
.fp-premium-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
}
@media (min-width: 768px) {
  .fp-premium-grid { grid-template-columns: 1fr 1fr; }
}
.fp-premium-card {
  background: #ffffff;
  padding: 32px;
  border-radius: 12px;
  border: 2px solid #215295;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -4px rgba(0, 0, 0, 0.1);
}
.fp-card-title {
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 500;
  margin: 0 0 12px;
}
.fp-card-desc {
  color: #4b5563;
  margin: 0 0 16px;
}
.fp-bullets {
  list-style: none;
  padding: 0;
  margin: 0;
}
.fp-bullets li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  color: #374151;
  margin-bottom: 8px;
}
.fp-bullets .dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #215295;
  margin-top: 9px;
  flex-shrink: 0;
}

/* CTA */
.fp-cta {
  text-align: center;
  padding: 64px 32px;
  border-radius: 16px;
  background-color: #215295;
}
.fp-cta-title {
  font-size: 1.875rem;
  line-height: 2.25rem;
  font-weight: 500;
  color: #ffffff;
  margin: 0 0 16px;
}
.fp-cta-subtitle {
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.9);
  margin: 0 0 32px;
}
.fp-cta-actions {
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  align-items: center;
}
@media (min-width: 640px) {
  .fp-cta-actions { flex-direction: row; }
}
.cta-btn {
  padding: 16px 32px;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.15s ease;
}
.cta-btn--white {
  background: #ffffff;
  color: #215295;
  border: 2px solid #ffffff;
}
.cta-btn--white:hover {
  background: #f3f4f6;
  border-color: #f3f4f6;
}
.cta-btn--outline {
  background: transparent;
  color: #ffffff;
  border: 2px solid #ffffff;
}
.cta-btn--outline:hover {
  background: rgba(255, 255, 255, 0.1);
}

@media (max-width: 599px) {
  .fp-title { font-size: 2.25rem; }
}

/* Animations */
.reveal {
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}
.reveal--visible {
  opacity: 1;
  transform: translateY(0);
}
/* @media (prefers-reduced-motion: reduce) {
  .reveal {
    opacity: 1;
    transform: none;
    transition: none;
  }
} */
</style>